import { TransactionType } from "@gtpl/shared-models/common-models";
import { Column, Entity, PrimaryColumn, PrimaryGeneratedColumn } from "typeorm";

@Entity('production_cost_analysis', { schema: 'public' })
export class ProductionCostAnalysisEntity{
    @PrimaryGeneratedColumn('increment', {name: 'id'})
    id: number;

    @Column('varchar',{
        name:'batch_no',
        length:50
    })
    batchNo : string

    @Column('varchar',{
        name:'variant',
        length:100
    })
    variant : string

    @Column('varchar',{
        name:'grade',
        length:50
    })
    grade : string

    @Column('int',{
        name:'variant_id',
    })
    variantId : number

    @Column('int',{
        name:'pack_style_id',
    })
    packStyleId : string

    @Column('varchar',{
        name:'pack_style',
        length:50
    })
    packStyle : string

    @Column('varchar',{
        name:'po_number',
        length:50
    })
    poNumber : string

    @Column('varchar',{
        name:'end_customer',
        length:100
    })
    endCustomer : string

    @Column('int',{
        name:'end_customer_id',
    })
    endCustomerId : string

    @Column('decimal',{
        name:'fg_qty_kgs',
        precision:10,scale:3,
        unsigned:true,
    })
    fgQtyKgs : number

    @Column('decimal',{
        name:'fg_yield',
        precision:10,scale:2,
    })
    fgYield : number

    @Column('decimal',{
        name:'pack_count',
        precision:10,scale:2,
    })
    packCount : number

    @Column('decimal',{
        name:'rm_count',
        precision:10,scale:2,
    })
    rmCount : number

    @Column('decimal',{
        name:'rm_rate',
        precision:10,scale:2,
    })
    rmRate : number

    @Column('decimal',{
        name:'rm_cost',
        precision:10,scale:2,
    })
    rmCost : number

    @Column('decimal',{
        name:'mfg_cost',
        precision:10,scale:2,
    })
    mfgCost : number

    @Column('decimal',{
        name:'packing_cost',
        precision:10,scale:2,
    })
    packingCost : number

    @Column('decimal',{
        name:'freight_frwd_cost',
        precision:10,scale:2,
    })
    freightFrwdCost : number

    @Column('decimal',{
        name:'sale_cost_kg_usd',
        precision:10,scale:2,
    })
    saleCostKgUsd : number

    @Column('decimal',{
        name:'sale_cost_kg_inr',
        precision:10,scale:2,
    })
    saleCostKgInr : number

    @Column('decimal',{
        name:'sale_cost_lb_usd',
        precision:10,scale:2,
    })
    saleCostLbUsd : number

    @Column('decimal',{
        name:'sale_price',
        precision:10,scale:2,
    })
    salePrice : number

    @Column('decimal',{
        name:'profit_loss',
        precision:10,scale:2,
    })
    profitLoss : number

    @Column('decimal',{
        name:'incentives',
        precision:10,scale:2,
    })
    incentives : number

    @Column('decimal',{
        name:'total_pl',
        precision:10,scale:2,
    })
    totalPl : number

    @Column('int',{
        name:'plant_id',
    })
    plantId : number

    @Column('int',{
        name:'company_id',
    })
    companyId : number

    @Column('int',{
        name:'cartons',
    })
    cartons : number

    @Column('int',{
        name:'loose_pouches',
    })
    loosePouches : number

    @Column('datetime',{
        name:'reported_date',
    })
    reportedDate : Date

    @Column('decimal',{
        name:'actual_mfg_kg',
        precision:10,scale:2,
    })
    actualMfgKg : number

    @Column('decimal',{
        name:'exchange_rate',
        precision:10,scale:2,
    })
    exchangeRate : number

    @Column('decimal',{
        name:'cal_rm_qty',
        precision:10,scale:2,
    })
    calRmQty : number

    @Column('decimal',{
        name:'rm_value',
        precision:10,scale:2,
    })
    rmValue : number

    @Column('decimal',{
        name:'actual_mfg_cost',
        precision:10,scale:2,
    })
    actualMfgCost : number

    @Column('decimal',{
        name:'net_cop',
        precision:10,scale:2,
    })
    netCop : number

    @Column('decimal',{
        name:'real_price_kg',
        precision:10,scale:2,
    })
    realPricePerKg : number

    @Column('decimal',{
        name:'real_value',
        precision:10,scale:2,
    })
    realValue : number

    @Column('varchar',{
        name:'basis',
        length:20
    })
    basis : string

    @Column('varchar',{
        name:'country',
        length:30
    })
    country : string

    @Column('int',{
        name:'pouches',
    })
    pouches : number

    @Column('decimal',{
        name:'pouch_weight',
        precision:10,scale:2,
    })
    pouchWeight : number

    @Column('int',{
        name:'uom_id',
    })
    uomId : number

    @Column('decimal',{
        name:'gross_pouch_weight',
        precision:10,scale:3,
    })
    grossPouchWeight : number

    @Column('decimal',{
        name:'gross_hon_weight',
        precision:10,scale:2,
    })
    grossHonWeight : number

    @Column('varchar',{
        name:'product_category',
        length:20
    })
    productCategory : string

    @Column('varchar',{
        name:'product',
        length:50
    })
    product : string

    @Column('varchar',{
        name:'food_type',
        length:10
    })
    foodType : string

    @Column('varchar',{
        name:'va_1',
        length:10
    })
    va1 : string

    @Column('varchar',{
        name:'va_2',
        length:10
    })
    va2 : string

    @Column('varchar',{
        name:'va_3',
        length:10
    })
    va3 : string

    @Column('varchar',{
        name:'va_4',
        length:10
    })
    va4 : string

    @Column('varchar',{
        name:'va_5',
        length:10
    })
    va5 : string

    @Column('int',{
        name:'reporting_id'
    })
    reportingId : number

    @Column('varchar',{
        name:'soak_style',
        length:50
    })
    soakStyle : string

    @Column('int',{
        name:'sale_order_id',
    })
    saleOrderId : number

    @Column('varchar',{
        name:'inv_num'
    })
    invoiceNumber:string

    @Column('decimal',{
        name:'fg_to_hon_weight_kg',
        nullable:true,
        precision:10,scale:3
    })
    fgToHonWeightKg : number

    @Column({
        type: 'enum',
        enum: TransactionType,
        nullable: false,
        name: 'transaction_type',
        default:TransactionType.palleting,
    })
    transactionType: TransactionType;

}